import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", { d: "M1 1.00002L15 1V17L7.95652 11.1818L1 17V1.00002Z" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_as_icon_base = _resolveComponent("as-icon-base")!

  return (_openBlock(), _createBlock(_component_as_icon_base, {
    width: "16",
    height: "19",
    "view-box": "0 0 16 19"
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}